export const appStoreURL: string =
  'https://apps.apple.com/ca/app/momentum-spine/id1665615234';
export const playStoreURL: string =
  'https://play.google.com/store/apps/details?id=com.momentum.spine.app';
export const appDeepLink: string = 'com.momentum.spine.app://';
